import languageService from "@/services/language.service";

languageService.initializeGettext();
const gettextInstance = languageService.getGettextInstance();

export default gettextInstance;